import React from 'react'
import Layout from '../components/layout'
import styled from 'styled-components'
import { graphql, useStaticQuery } from 'gatsby'
import { colors, bp } from '../styles/colors'
import { MediumTitle, GreyText } from '../styles/fonts'
import BackButton from '../components/backButton'

const Kemikaaliluettelo = () => {
    
    const data = useStaticQuery(graphql`
        query Lista {
            kemikaalit: allFile( filter: {extension: { eq: "pdf" }}, sort: {fields: name} ) {
                edges {
                    node {
                        name
                        publicURL
                    }
                }
            }
        }
    `)

    return(
        <Layout>
            <SectionWrapper>
               <ButtonContainer><BackButton to={'/'}/></ButtonContainer>
                <Title>Kemikaaliluettelo</Title>
                <GreyText>Avaa tuotteen tiedot klikkaamalla</GreyText>
                <ListContainer>
                    {data.kemikaalit.edges.map(item => (
                        <ListItem> <A href={item.node.publicURL} target="_blank">{item.node.name}</A> </ListItem>
                    ))}
                </ListContainer>
            </SectionWrapper>
        </Layout>
    )
}


const ButtonContainer = styled.div`
    display: flex;
    min-width: 80%;
    @media screen and (max-width: ${bp.mobile}) {
        margin-top: 14rem;
        max-width: 90%;
    }
    
`

const SectionWrapper = styled.div`

    max-width: 80%;
    margin: auto;
    @media screen and (max-width: ${bp.mobile}) {
        max-width: 90%;
    }
`
const Title = styled(MediumTitle)`
    margin-top: 0rem;
    @media screen and (max-width: ${bp.mobile}) {
        margin-top: 1rem;
        font-size: 2rem;
    }
`

const ListContainer = styled.div`
    padding: 2rem 0rem;
`

const ListItem = styled.li`
    margin-bottom: 0.6rem;
    color: ${colors.grey4};
`
const A = styled.a`
    &:hover {
        color: ${colors.black};
    }
`

export default Kemikaaliluettelo